/**
 * The canonical record vocabulary per form: every column the per-form generators read.
 *
 * Harvested from the TypeScript interfaces that moved with the generators
 * (forms/<form>/interface/*.ts), so it stays the same vocabulary the upload templates use.
 * 1042-S ships no interface in core-api, so its keys come from the generator source itself.
 */
export const FORM_FIELDS: Record<string, string[]> = {
  "1099-NEC": [
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_NAME2",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_ID_TYPE",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_FIRST_NAME",
    "RECIPIENT_MIDDLE_NAME",
    "RECIPIENT_LAST_NAME",
    "RECIPIENT_SUFFIX",
    "RECIPIENT_BUSINESS_NAME1",
    "RECIPIENT_BUSINESS_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_ADDRESS3",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "FOREIGN_COUNTRY",
    "ACCOUNT_NUMBER",
    "BOX1_NONEMPLOYEE_COMPENSATION",
    "BOX1A_NONEMPLOYEE_COMPENSATION",
    "BOX1B_CASH_TIPS",
    "BOX1C_TTOC1",
    "BOX1C_TTOC2",
    "BOX1D_OVERTIME_COMPENSATION",
    "FILER_SUITE_NO",
    "FILER_COUNTRY",
    "RECIPIENT_APT_NO",
    "BOX4_FED_INCOME_TAX_WITHHELD",
    "BOX3_GOLDEN_PARACHUTE",
    "BOX5_STATE_TAX_WITHHELD1",
    "BOX6_PAYER_STATE_NUMBER1",
    "BOX7_STATE_INCOME1",
    "BOX5_STATE_TAX_WITHHELD2",
    "BOX6_PAYER_STATE_NUMBER2",
    "BOX7_STATE_INCOME2",
    "BOX2_DIRECT_SALE",
    "BOX2_DIRECT_SALES",
    "FATCA_REQUIREMENT",
    "1099_YEAR",
    "YEAR",
    "id",
    "corrected",
    "TaxYr",
    "RecipientTIN",
    "RecipientName",
    "PersonFirstNm",
    "PersonLastNm",
    "RecipientAddress",
    "AddressLine1Txt",
    "CityNm",
    "StateAbbreviationCd",
    "ZIPCd",
    "StateLocalTaxGrp",
    "StateTaxGrp",
    "StateTaxWithheldAmt",
    "StateIncomeAmt",
  ],
  "1099-MISC": [
    "FILER_NAME2",
    "FILER_SUITE_NO",
    "FILER_COUNTRY",
    "RECIPIENT_APT_NO",
    "SECTION_409A_INCOME",
    "id",
    "SITE_ID",
    "1099_YEAR",
    "BOX13A_CASH_TIPS",
    "BOX13B_TTOC1",
    "BOX13B_TTOC2",
    "BOX14_OVERTIME_COMPENSATION",
    "RECIPIENT_ID_TYPE",
    "RECIPIENT_FIRST_NAME",
    "RECIPIENT_MIDDLE_NAME",
    "RECIPIENT_LAST_NAME",
    "RECIPIENT_SUFFIX",
    "RECIPIENT_BUSINESS_NAME1",
    "RECIPIENT_BUSINESS_NAME2",
    "SSN/TIN",
    "RECIPIENT_NAME",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "FOREIGN_COUNTRY",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_FEDERAL_ID_NUMBER",
    "BOX_2ND_TIN_NOT_IND",
    "BOX13_FATCA_REQUIREMENT",
    "FATCA_REQUIREMENT",
    "BOX1_RENTS",
    "BOX2_ROYALTIES",
    "BOX3_OTHER_INCOME",
    "BOX4_FED_INCOME_TAX_WITHHELD",
    "BOX5_FISHING_BOAT_PROCEEDS",
    "BOX6_MEDICAL_HEALTHCARE_PAYMENTS",
    "BOX8_SUBSTITUTE_PAYMENTS",
    "BOX9_CROP_INSURANCE_PROCEEDS",
    "BOX10_GROSS_PROCEEDS_ATTORNEY",
    "BOX12_SECTION_409A_DEFERRAL",
    "BOX13_GOLDEN_PARACHUTE",
    "BOX14_GOLDEN_PARACHUTE",
    "BOX15_NONQUALIFIED_COMPENSATION",
    "BOX15_STATE_TAX_WITHHELD2",
    "BOX16_STATE_INCOME1",
    "BOX16_STATE_INCOME2",
    "customerFileId",
    "FILER_ADDRESS2",
    "FILER_PHONE",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_ADDRESS3",
    "FOREIGN_COUNTRY_INDICATOR",
    "Recipient_Email",
    "ACCOUNT_NUMBER",
    "BOX7_DIRECT_SALES_IND",
    "RECIPIENT_EMAIL",
    "BOX17_PAYER_STATE_NUMBER1",
    "BOX17_PAYER_STATE_NUMBER2",
    "RECIPIENT_ID_NUMBER",
    "BOX18_STATE_INCOME1",
    "BOX18_STATE_INCOME2",
    "BOX16_STATE_TAX_WITHHELD1",
    "entraid",
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedAt",
    "deletedBy",
    "isDeleted",
    "BOX16_STATE_TAX_WITHHELD2",
    "updated",
    "refId",
    "eFiled",
    "BOX11_FISH_PURCHASED_RESALE",
    "corrected",
    "userId",
    "manual",
    "manualRecordId",
    "SEQUENCE_ID",
  ],
  "1099-INT": [
    "RECIPIENT_ID_TYPE",
    "RECIPIENT_FIRST_NAME",
    "RECIPIENT_MIDDLE_NAME",
    "RECIPIENT_LAST_NAME",
    "RECIPIENT_SUFFIX",
    "RECIPIENT_BUSINESS_NAME1",
    "RECIPIENT_BUSINESS_NAME2",
    "id",
    "corrected",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_PHONE",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "BOX_2ND_TIN_NOT_IND",
    "RECIPIENT_ID_NUMBER",
    "ACCOUNT_NUMBER",
    "FATCA_REQUIREMENT",
    "BOX1_INTEREST_INCOME_NOT_IN_BOX3",
    "BOX2_EARLY_WITHDRAWAL_PENALTY",
    "BOX3_INTEREST_ON_US_SAVINGS",
    "BOX4_FED_INCOME_TAX_WITHHELD",
    "BOX5_INVESTMENT_EXPENSES",
    "BOX6_FOREIGN_TAX_PAID",
    "BOX7_FOREIGN_COUNTRY_US_POSSESSION",
    "BOX8_TAX_EXEMPT_INTEREST",
    "BOX9_SPEC_PRIVATE_ACT_BOND_INT",
    "BOX10_MARKET_DISCOUNT_BOND",
    "BOX11_BOND_PREMIUM",
    "BOX12_BOND_PREMIUM_ON_TREASURY",
    "BOX13_TAX_EXEMPT_BOND",
    "BOX14_TAX_EXEMPT_BOND_CUSIP",
    "BOX15_STATE",
    "BOX15_STATE2",
    "BOX16_STATE_ID",
    "BOX16_STATE_ID2",
    "BOX17_STATE_TAX_WITHHELD",
    "BOX17_STATE_TAX_WITHHELD2",
    "1099_YEAR",
    "SITE_ID",
    "userId",
    "createdBy",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "ISSUER_OFFICE_CD",
    "CFSF_ELECTION_STATE_CD",
    "PAYER_ROUTING_TRANSIT_NUM",
    "PREV_UNIQUE_RECORD_ID",
    "PREV_RECIPIENT_NAME",
    "PREV_RECIPIENT_TIN",
  ],
  "1099-DIV": [
    "RECIPIENT_ID_TYPE",
    "RECIPIENT_FIRST_NAME",
    "RECIPIENT_MIDDLE_NAME",
    "RECIPIENT_LAST_NAME",
    "RECIPIENT_SUFFIX",
    "RECIPIENT_BUSINESS_NAME1",
    "RECIPIENT_BUSINESS_NAME2",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "RECIPIENT_EMAIL",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "ACCOUNT_NUMBER",
    "BOX1A_TOTAL_ORDINARY_DIVIDENDS",
    "BOX1B_QUALIFIED_DIVIDENDS",
    "BOX2A_TOTAL_CAPITAL_GAIN_DISTR",
    "BOX2B_UNRECAP_SEC_1250_GAIN",
    "BOX2C_SECTION_1202_GAIN",
    "BOX2D_COLLECTIBLES_GAIN",
    "BOX2E_SECTION_897_ORD_DIV",
    "BOX2F_SECTION_897_CAP_GAIN",
    "BOX3_NONDIVIDEND_DISTRIBUTIONS",
    "BOX4_FEDERAL_INCOME_TAX_WITHHELD",
    "BOX5_SECTION_199A_DIVIDENDS",
    "BOX6_INVESTMENT_EXPENSES",
    "BOX7_FOREIGN_TAX_PAID",
    "BOX8_FOREIGN_COUNTRY",
    "BOX9_CASH_LIQUIDATION_DISTRIBUTIONS",
    "BOX10_NONCASH_LIQUIDATION_DISTRIBUTIONS",
    "BOX_2ND_TIN_NOT_IND",
    "BOX11_FATCA_REQUIREMENT",
    "BOX12_EXEMPT_INTEREST_DIVIDENDS",
    "BOX13_SPECIFIED_PRIVATE_ACTIVITY_BOND",
    "BOX14_STATE1",
    "BOX14_STATE2",
    "BOX15_STATE_IDENTIFICATION_NO1",
    "BOX15_STATE_IDENTIFICATION_NO2",
    "BOX16_STATE_TAX_WITHHELD1",
    "BOX16_STATE_TAX_WITHHELD2",
    "1099_YEAR",
    "id",
    "corrected",
  ],
  "1099-R": [
    "id",
    "SITE_ID",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "FOREIGN_COUNTRY",
    "FOREIGN_COUNTRY_INDICATOR",
    "RECIPIENT_EMAIL",
    "ACCOUNT_NUMBER",
    "BOX1_GROSS_DISTRIBUTION",
    "BOX2A_TAXABLE_AMOUNT",
    "BOX2B_TAXABLE_AMOUNT_IND",
    "BOX2B_TOTAL_DISTRIBUTION_IND",
    "BOX3_CAPITAL_GAIN",
    "BOX4_FEDERAL_INCOME_TAX_WITHHELD",
    "BOX5_EMPLOYEE_CONTRIBUTIONS",
    "BOX6_UNREALIZED_APPRECIATION",
    "BOX7_DISTRIBUTION_CODES",
    "BOX7_IRA_SEP_SIMPLE_IND",
    "BOX7_TRUMP_ACCOUNT",
    "BOX7_EARNINGS_EXCESS_CONTRIBUTIONS",
    "BOX8_OTHER",
    "BOX8_PERCENT",
    "BOX9A_PERCENT_OF_DISTRIBUTION",
    "BOX9B_TOT_EMPLOYEE_CONTRIBUTIONS",
    "BOX10_AMOUNT_ALLOCABLE",
    "BOX11_ROTH_CONTRIBUTION",
    "BOX12_FATCA_REQUIREMENT",
    "BOX13_DATE_OF_PAYMENT",
    "BOX14_STATE_TAX_WITHHELD1",
    "BOX14_STATE_TAX_WITHHELD2",
    "BOX15_PAYERS_STATE_NO1",
    "BOX15_PAYERS_STATE_NO2",
    "BOX16_STATE_DISTRIBUTION1",
    "BOX16_STATE_DISTRIBUTION2",
    "BOX17_LOCAL_TAX_WITHHELD1",
    "BOX17_LOCAL_TAX_WITHHELD2",
    "BOX18_NAME_OF_LOCALITY1",
    "BOX18_NAME_OF_LOCALITY2",
    "BOX19_LOCAL_DISTRIBUTION1",
    "BOX19_LOCAL_DISTRIBUTION2",
    "1099_YEAR",
    "customerFileId",
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedAt",
    "deletedBy",
    "isDeleted",
    "corrected",
    "eFiled",
    "userId",
    "userid",
    "manual",
    "manualRecordId",
    "refId",
    "updated",
    "SEQUENCE_ID",
    "StateLocalTaxGrp",
    "StateTaxGrp",
    "StateAbbreviationCd",
    "StateDistributionAmt",
    "StateTaxWithheldAmt",
    "LocalTaxGrp",
    "LocalDistributionAmt",
    "LocalAbbreviationCdTxt",
    "LocalTaxWithheldAmt",
    "PayerDetail",
    "PayerId",
    "PayerEIN",
    "PayerNm",
    "PayerUSAddress",
    "AddressLine1Txt",
    "AddressLine2Txt",
    "CityNm",
    "ZIPCd",
  ],
  "1099-K": [
    "corrected",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_PHONE",
    "PAYEE_NAME",
    "PAYEE_NAME2",
    "PAYEE_ADDRESS1",
    "PAYEE_ADDRESS2",
    "PAYEE_CITY",
    "PAYEE_STATE",
    "PAYEE_ZIP",
    "PAYEE_ID_NUMBER",
    "TYPE_OF_FILER_INDICATOR_PSE",
    "TYPE_OF_FILER_INDICATOR_3RD_PARTY",
    "TYPE_OF_PAYMENT_INDICATOR_PAYMENT_CARD",
    "TYPE_OF_PAYMENT_INDICATOR_THIRD_PARTY",
    "PSE_NAME",
    "PSE_TELEPHONE",
    "PAYEE_INTERNAL_ACCT_NO",
    "PAYEE_TIN",
    "BOX1A_GROSS_AMT_PAYMENT_CARD_TPN_TRANS",
    "BOX1B_CARD_NOT_PRESENT_TRANS",
    "BOX5A_JANUARY",
    "BOX5C_MARCH",
    "BOX5E_MAY",
    "BOX5G_JULY",
    "BOX5I_SEPTEMBER",
    "BOX5J_OCTOBER",
    "BOX6_STATE",
    "BOX4_FED_INCOME_TAX_WTHLD",
    "BOX3_NO_PAYMENT_TRANSACTIONS",
    "BOX5B_FEBRUARY",
    "BOX5D_APRIL",
    "BOX5F_JUNE",
    "BOX5H_AUGUST",
    "BOX5K_NOVEMBER",
    "BOX5L_DECEMBER",
    "BOX7_STATE_ID_NO",
    "BOX8A_STATE_INCOME_TAX_WTHLD",
    "1099_YEAR",
    "SITE_ID",
    "userId",
    "createdBy",
    "BOX2_MERCHANT_CAT_CODE",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "id",
  ],
  "1099-SA": [
    "corrected",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_PHONE",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "BOX_RECIPIENT_ID_NUMBER",
    "BOX_ACCOUNT_NUMBER",
    "BOX1_GROSS_DISTRIBUTION",
    "BOX2_EARNING_ON_EXCESS",
    "BOX3_DISTRIBUTION_CODE",
    "BOX4_FMV_ON_DATE_OF_DEATH",
    "BOX5_HSA",
    "BOX5_ARCHER_MSA",
    "BOX5_MA_MSA",
    "1099_YEAR",
    "id",
  ],
  "1099-C": [
    "id",
    "corrected",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "ACCOUNT_NUMBER",
    "BOX1_DATE_OF_IDENTIFIABLE_EVENT",
    "BOX2_AMT_OF_DEBT_DISCHARGED",
    "BOX3_INTEREST_INCL_IN_BOX2",
    "BOX4_DEBT_DESCRIPTION",
    "BOX5_BORROWER_LIABLE_YES_IND",
    "BOX5_BORROWER_LIABLE_NO_IND",
    "BOX6_IDENTIFIABLE_EVENT_CODE",
    "BOX7_FAIR_MARKET_VALUE",
    "1099_YEAR",
    "SITE_ID",
    "userId",
    "createdBy",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
  ],
  "1099-LTC": [
    "corrected",
    "id",
    "POLICYHOLDER_NAME",
    "POLICYHOLDER_STREET_ADDRESS_1",
    "POLICYHOLDER_STREET_ADDRESS_2",
    "POLICYHOLDER_CITY",
    "POLICYHOLDER_STATE",
    "POLICYHOLDER_ZIP_CODE",
    "POLICYHOLDER_TAX_ID",
    "INSURED_NAME",
    "INSURED_STREET_ADDRESS_1",
    "INSURED_STREET_ADDRESS_2",
    "INSURED_CITY",
    "INSURED_STATE",
    "INSURED_ZIP_CODE",
    "INSURED_SSN",
    "INSURED_ACCOUNT_NUMBER",
    "BOX1_GROSS_BENEFITS_PAID",
    "BOX2_ACCELERATED_DEATH_BENEFITS_PAID",
    "PAYMENT_TYPE",
    "QUALIFIED_CONTRACT",
    "CHRONICALLY_ILL",
    "TERMINAL_ILL",
    "PER_DIEM",
    "REIMBURSED_AMOUNT",
    "DATE_CERTIFIED",
    "PAYER_NAME",
    "PAYER_STREET_ADDRESS_1",
    "PAYER_STREET_ADDRESS_2",
    "PAYER_CITY",
    "PAYER_STATE",
    "PAYER_ZIP_CODE",
    "PAYER_PHONE",
    "PAYERS_TIN",
    "1099_YEAR",
    "SITE_ID",
    "userId",
    "createdBy",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
  ],
  "1099-B": [
    "id",
    "corrected",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME1",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "FOREIGN_COUNTRY",
    "FOREIGN_COUNTRY_INDICATOR",
    "RECIPIENT_EMAIL",
    "ACCOUNT_NUMBER",
    "CUSIP_NUMBER",
    "FATCA_REQUIREMENT",
    "FORM_8949_CHECKBOX",
    "BOX_1A_DESCRIPTION",
    "BOX_1B_DATE_ACQUIRED",
    "BOX_1C_DATE_SOLD",
    "BOX_1D_PROCEEDS",
    "BOX_1E_COST_BASIS",
    "BOX_1F_MARKET_DISCOUNT",
    "BOX_1G_WASH_SALE_LOSS",
    "BOX_2_SHORT_TERM_INDICATOR",
    "BOX_2_LONG_TERM_INDICATOR",
    "BOX_2_ORDINARY_INDICATOR",
    "BOX_3_PROCEEDS_COLLECTIBLES",
    "BOX_3_PROCEEDS_QOF",
    "BOX_4_FEDERAL_TAX_WITHHELD",
    "BOX_5_NONCOVERED_SECURITY_INDICATOR",
    "BOX_6_GROSS_PROCEEDS_INDICATOR",
    "BOX_6_NET_PROCEEDS_INDICATOR",
    "BOX_7_LOSS_NOT_ALLOWED_INDICATOR",
    "BOX_8_PROFIT_LOSS_2019",
    "BOX_9_UNREALIZED_PL_2018",
    "BOX_10_UNREALIZED_PL_2019",
    "BOX_11_AGGREGATE_PL",
    "BOX_12_PROCEEDS_COLLECTIBLES_INDICATOR",
    "BOX_13_BARTERING",
    "BOX_14_STATE_NAME1",
    "BOX_15_STATE_ID1",
    "BOX_16_STATE_TAX_WITHHELD1",
    "BOX_14_STATE_NAME2",
    "BOX_15_STATE_ID2",
    "BOX_16_STATE_TAX_WITHHELD2",
    "1099_YEAR",
    "customerFileId",
    "createdAt",
    "createdBy",
    "updatedAt",
    "updatedBy",
    "deletedAt",
    "deletedBy",
    "isDeleted",
    "eFiled",
  ],
  // Form 1099-Q: the keys of forms/1099-Q/interface/1099-Q-interface.ts. The e-file app is the
  // only place 1099-Q is defined, so these names are its own (2026 split-name layout).
  "1099-Q": [
    "id",
    "corrected",
    "SITE_ID",
    "1099_YEAR",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_NAME2",
    "FILER_ADDRESS1",
    "FILER_SUITE_NO",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_COUNTRY",
    "FILER_PHONE",
    "RECIPIENT_ID_TYPE",
    "RECIPIENT_ID_NUMBER",
    // The combined name, upload only: split into the fields below before the XML (TS-8758).
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_FIRST_NAME",
    "RECIPIENT_MIDDLE_NAME",
    "RECIPIENT_LAST_NAME",
    "RECIPIENT_SUFFIX",
    "RECIPIENT_BUSINESS_NAME1",
    "RECIPIENT_BUSINESS_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_APT_NO",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "ACCOUNT_NUMBER",
    "BOX1_GROSS_DISTRIBUTION",
    "BOX2_EARNINGS",
    "BOX3_BASIS",
    "BOX4A_TRUSTEE_TO_TRUSTEE_TRANSFER",
    "BOX4B_QTP_TO_ROTH_IRA_TRANSFER",
    "BOX5_PRIVATE_QTP",
    "BOX5_STATE_QTP",
    "BOX5_COVERDELL_ESA",
    "BOX6_NOT_DESIGNATED_BENEFICIARY",
    "DISTRIBUTION_CODE",
  ],
  // Form 1098 (TS-8587): the keys of forms/1098/interface/1098-interface.ts, which are the
  // 2026 client template headers verbatim.
  "1098": [
    "id",
    "corrected",
    "SITE_ID",
    "1098_YEAR",
    "LENDER_FEDERAL_ID_NUMBER",
    "LENDER_NAME",
    "LENDER_ADDRESS1",
    "LENDER_SUITE_NO",
    "LENDER_ADDRESS2",
    "LENDER_CITY",
    "LENDER_STATE",
    "LENDER_ZIP",
    "LENDER_COUNTRY",
    "LENDER_PHONE",
    "BORROWER_ID_TYPE",
    "BORROWER_ID_NUMBER",
    "BORROWER_FIRST_NAME",
    "BORROWER_MIDDLE_NAME",
    "BORROWER_LAST_NAME",
    "BORROWER_SUFFIX",
    "BORROWER_COMPANY_NAME",
    "RECIPIENT_BUSINESS_NAME2",
    "BORROWER_ADDRESS1",
    "BORROWER_APT_NO",
    "BORROWER_ADDRESS2",
    "BORROWER_CITY",
    "BORROWER_STATE",
    "BORROWER_ZIP",
    "FOREIGN_COUNTRY_INDICATOR",
    "BORROWER_COUNTRY",
    "BORROWER_ACCOUNT_NUMBER",
    "AMORTIZATION",
    "REAL_ESTATE_TAXES",
    "CAPITAL_RESERVE",
    "BOX1_MORTGAGE_INTEREST",
    "BOX2_OUTSTANDING_MORTGAGE_PRINCIPAL",
    "BOX3_MORTGAGE_ORIGNATION_DATE",
    "BOX4_REFUND_OF_OVERPAID_INTEREST",
    "BOX_5_MORTGAGE_INSURANCE_PREMIUM",
    "BOX6_POINTS_PAID",
    "BOX7_ADDRESS_OF_PROPERTY_SECURING_MORTGAGE_IS_THE_SAME",
    "BOX8_ADDRESS_OR_DESCRIPTION_OF_PROPERTY_LINE_1",
    "BOX8_ADDRESS_OR_DESCRIPTION_OF_PROPERTY_LINE_2",
    "BOX8_ADDRESS_OR_DESCRIPTION_OF_PROPERTY_LINE_3",
    "BOX9_NUMBER_OF_PROPERTIES",
    "BOX10_OTHER",
    "BOX11_MORTGAGE_ACQUISITION_DATE",
  ],
  "1098-E": [
    "id",
    "corrected",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "ACCOUNT_NUMBER",
    "BOX1_DATE_OF_IDENTIFIABLE_EVENT",
    "BOX2_AMT_OF_DEBT_DISCHARGED",
    "BOX2_LOAN_ORIGINATION_FEES_IND",
    "BOX3_INTEREST_INCL_IN_BOX2",
    "BOX4_DEBT_DESCRIPTION",
    "BOX5_BORROWER_LIABLE_YES_IND",
    "BOX6_IDENTIFIABLE_EVENT_CODE",
    "BOX7_FAIR_MARKET_VALUE",
    "1099_YEAR",
    "SITE_ID",
    "userId",
    "createdBy",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "BORROWER_SSN",
    "BORROWER_NAME",
    "BORROWER_NAME2",
    "BORROWER_ADDRESS1",
    "BORROWER_ADDRESS2",
    "BORROWER_CITY",
    "BORROWER_STATE",
    "BORROWER_ZIP",
    "BOX1_STUDENT_LOAN_INTEREST",
    "BOX2_PRE_2004_ORIGINATION_FEES",
    "BORROWER_ACCOUNT_NUMBER",
    "FILER_PHONE2",
  ],
  "1098-T": [
    "id",
    "corrected",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "ACCOUNT_NUMBER",
    "BOX1_DATE_OF_IDENTIFIABLE_EVENT",
    "BOX2_AMT_OF_DEBT_DISCHARGED",
    "BOX2_LOAN_ORIGINATION_FEES_IND",
    "BOX3_INTEREST_INCL_IN_BOX2",
    "BOX4_DEBT_DESCRIPTION",
    "BOX5_BORROWER_LIABLE_YES_IND",
    "BOX6_IDENTIFIABLE_EVENT_CODE",
    "BOX7_FAIR_MARKET_VALUE",
    "SITE_ID",
    "userId",
    "createdBy",
    "FOREIGN_COUNTRY_INDICATOR",
    "FOREIGN_COUNTRY",
    "BORROWER_SSN",
    "BORROWER_NAME",
    "BORROWER_NAME2",
    "BORROWER_ADDRESS1",
    "BORROWER_ADDRESS2",
    "BORROWER_CITY",
    "BORROWER_STATE",
    "BORROWER_ZIP",
    "BOX1_STUDENT_LOAN_INTEREST",
    "BOX2_PRE_2004_ORIGINATION_FEES",
    "BORROWER_ACCOUNT_NUMBER",
    "FILER_PHONE2",
    "FILER_ADDRESS3",
    "JOB_NUMBER",
    "STUDENT_SSN",
    "STUDENT_FIRST_NAME",
    "STUDENT_MIDDLE_NAME",
    "STUDENT_LAST_NAME",
    "STUDENT_ADDRESS1",
    "STUDENT_ADDRESS2",
    "STUDENT_CITY",
    "STUDENT_STATE",
    "STUDENT_ZIP",
    "EMAIL",
    "SCHOOL_STUDENT_ID",
    "BOX1_PAYMENTS_RECEIVED",
    "BOX4_ADJ_MADE_PRIOR_YR",
    "BOX5_SCHOLARSHIP_GRANTS",
    "BOX6_ADJ_SCHOLARSHIP_PRIOR_YR",
    "BOX7_ACADEMIC_PERIOD_IND",
    "BOX8_HALF_TIME_STUDENT_IND",
    "BOX9_GRADUATE_STUDENT_IND",
    "BOX10_REIMBURSEMENT_OR_REFUND",
    "SSN_SOLICITED",
    "TOKEN",
    "STUDENT_CONSENT_DATE",
  ],
  "5498-SA": [
    "corrected",
    "FILER_NAME",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_PHONE",
    "RECIPIENT_NAME",
    "RECIPIENT_NAME2",
    "RECIPIENT_ADDRESS1",
    "RECIPIENT_ADDRESS2",
    "RECIPIENT_CITY",
    "RECIPIENT_STATE",
    "RECIPIENT_ZIP",
    "BOX_RECIPIENT_ID_NUMBER",
    "BOX_ACCOUNT_NUMBER",
    "BOX1_GROSS_DISTRIBUTION",
    "BOX2_EARNING_ON_EXCESS",
    "BOX3_DISTRIBUTION_CODE",
    "BOX4_FMV_ON_DATE_OF_DEATH",
    "BOX5_HSA",
    "BOX5_ARCHER_MSA",
    "BOX5_MA_MSA",
    "1099_YEAR",
    "id",
    "SITE_ID",
    "RECIPIENT_ID_NUMBER",
    "RECIPIENT_ADDRESS3",
    "FOREIGN_COUNTRY",
    "ACCOUNT_NUMBER",
    "BOX1_ARCHER_MSA_CONTRIBUTIONS",
    "BOX2_TOTAL_CONTRIBUTIONS",
    "BOX3_TOTAL_HSA_ARCHER_CONTRIBUTIONS",
    "BOX4_ROLLOVER_CONTRIBUTIONS",
    "BOX5_FAIR_MARKET_VALUE_HSA_ARCHER_MSA_MA_MSA",
    "BOX6_HSA",
    "BOX6_ARCHER_MSA",
    "BOX6_MA_MSA",
  ],
  "3921": [
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_NAME2",
    "FILER_ADDRESS1",
    "FILER_ADDRESS2",
    "FILER_ADDRESS3",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "FILER_PHONE",
    "RECIPIENT_ID_NUMBER",
    "EMPLOYEE_NAME",
    "EMPLOYEE_NAME2",
    "EMPLOYEE_ADDRESS1",
    "EMPLOYEE_ADDRESS2",
    "EMPLOYEE_ADDRESS3",
    "EMPLOYEE_CITY",
    "EMPLOYEE_STATE",
    "EMPLOYEE_ZIP",
    "RECIPIENT_EMAIL",
    "ACCOUNT_NUMBER",
    "BOX1_DATE_GRANTED",
    "BOX2_DATE_EXERCISED",
    "BOX3_EXE_PRICE_PER_SHARE",
    "BOX4_FAIR_MARKET_VALUE_ON_SHARE",
    "BOX5_SHARES_TRANSFERRED",
    "BOX6_EIN",
    "BOX6_COMPANY",
    "BOX6_ADDRESS",
    "BOX_6D",
    "1099_YEAR",
    "id",
    "corrected",
    "EMPLOYEE_SSN",
    "SEQUENCE_ID",
    "transectionId",
    "TaxYr",
    "RecordId",
    "VoidInd",
    "CorrectedInd",
    "RecipientDetail",
    "TIN",
    "PersonName",
    "PersonFirstNm",
    "PersonLastNm",
    "MailingAddressGrp",
    "USAddress",
    "AddressLine1Txt",
    "AddressLine2Txt",
    "CityNm",
    "StateAbbreviationCd",
    "ZIPCd",
    "RecipientAccountNum",
    "StockOptionGrantedDt",
    "StockOptionExercisedDt",
    "ExercisePricePerShareAmt",
    "FMVPerShareOnExerciseDtAmt",
    "SharesTransferredCnt",
    "OtherThanTransferorGrp",
    "BusinessName",
    "BusinessNameLine1Txt",
  ],
  "3922": [
    "Site_ID",
    "Tax_Year",
    "CORPORATION_NAME_1",
    "CORPORATION_NAME_2",
    "CORPORATION_ADDRESS",
    "CORPORATION_CITY",
    "CORPORATION_STATE",
    "CORPORATION_ZIP",
    "CORPORATION_PHONE",
    "CORPORATION_EIN",
    "EMPLOYEE_NAME",
    "EMPLOYEE_ADDRESS_1",
    "EMPLOYEE_ADDRESS_2",
    "EMPLOYEE_ADDRESS_3",
    "EMPLOYEE_CITY",
    "EMPLOYEE_STATE",
    "EMPLOYEE_ZIP",
    "EMPLOYEE_ACCOUNT_NO",
    "BOX1_DATE_GRANTED",
    "BOX2_DATE_EXERCISED",
    "BOX3_FAIR_MARKET_VALUE_GRANT_DATE",
    "BOX4_FAIR_MARKET_VALUE_EXE_DATE",
    "BOX5_EXERCISE_PRICE_PAID",
    "BOX6_NO_SHARES_TRANSFERRED",
    "BOX7_DATE_TITLE_TRANSFERRED",
    "BOX8_EXERCISE_PRICE_PAID_ON_GRANT_DATE",
    "1099_YEAR",
    "id",
    "corrected",
    "RECIPIENT_ID_NUMBER",
    "EMPLOYEE_SSN",
    "SEQUENCE_ID",
    "transectionId",
    "TaxYr",
    "RecordId",
    "VoidInd",
    "CorrectedInd",
    "RecipientDetail",
    "TIN",
    "PersonName",
    "PersonFirstNm",
    "PersonLastNm",
    "MailingAddressGrp",
    "USAddress",
    "AddressLine1Txt",
    "AddressLine2Txt",
    "CityNm",
    "StateAbbreviationCd",
    "ZIPCd",
    "RecipientAccountNum",
    "StockOptionGrantedDt",
    "StockOptionExercisedDt",
    "FMVPerShareOnGrantDtAmt",
    "FMVPerShareOnExerciseDtAmt",
    "ExercisePricePerShareAmt",
    "SharesTransferredCnt",
    "LegalTitleTransferDt",
    "ExercisePricePerShrGrantDtAmt",
  ],
  "1042-S": [
    "A2A",
    "BOX11_TAX_PAID_WITHHOLDING_AGENT",
    "BOX12A_WITHHOLDING_AGENT_EIN",
    "BOX12B_WITHHOLDING_AGENT_CH3_STATUS_CODE",
    "BOX12C_WITHHOLDING_AGENT_CH4_STATUS_CODE",
    "BOX12D_WITHHOLDING_AGENT_NAME1",
    "BOX12E_WITHHOLDING_AGENTS_GIIN",
    "BOX12F_WITHHOLDING_AGENT_COUNTRY_CODE",
    "BOX12G_WITHHOLDING_AGENT_FOREIGN_TIN",
    "BOX12H_WITHHOLDING_AGENT_ADDRESS1",
    "BOX12H_WITHHOLDING_AGENT_ADDRESS2",
    "BOX12I_WITHHOLDING_AGENT_CITY",
    "BOX12I_WITHHOLDING_AGENT_FOREIGN_INDICATOR",
    "BOX12I_WITHHOLDING_AGENT_PROVINCE_CODE",
    "BOX12I_WITHHOLDING_AGENT_STATE_CODE",
    "BOX12I_WITHHOLDING_AGENT_ZIP",
    "BOX13A_RECIPIENT_NAME1",
    "BOX13B_RECIPIENT_COUNTRY_CODE",
    "BOX13C_RECIPIENT_ADDRESS1",
    "BOX13C_RECIPIENT_ADDRESS2",
    "BOX13D_RECIPIENT_CITY",
    "BOX13D_RECIPIENT_COUNTRY",
    "BOX13D_RECIPIENT_FOREIGN_INDICATOR",
    "BOX13D_RECIPIENT_PROVINCE",
    "BOX13D_RECIPIENT_STATE",
    "BOX13D_RECIPIENT_ZIP",
    "BOX13E_RECIPIENT_US_TIN",
    "BOX13F_RECIPIENT_CH3_STATUS_CODE",
    "BOX13G_RECIPIENT_CH4_STATUS_CODE",
    "BOX13I_RECIPIENTS_FOREIGN_TIN",
    "BOX13J_RECIPIENT_LOB_CODE",
    "BOX13K_RECIPIENTS_ACCT_NO",
    "BOX14A_PRIMARY_WITHHOLDING_AGENT_NAME1",
    "BOX14B_PRIMARY_WITHHOLDING_AGENT_EIN",
    "BOX15_PRO_RATA_BASIS_REPORTING_INDICATOR",
    "BOX17A_STATE_INCOME_TAX_WITHHELD",
    "BOX17B_PAYERS_STATE_TAX_NO",
    "BOX17C_NAME_OF_STATE",
    "BOX1_INCOME_CODE",
    "BOX2_GROSS_INCOME",
    "BOX3A_EXEMPTION_CODE",
    "BOX3B_TAX_RATE",
    "BOX3_CHAPTER_INDICATOR",
    "BOX4A_EXEMPTION_CODE",
    "BOX4B_TAX_RATE",
    "BOX5_WITHHOLDING_ALLOWANCE",
    "BOX6_NET_INCOME",
    "BOX7A_FEDERAL_TAX_WITHHELD",
    "BOX7B_TAX_NOT_DEP_W_IRS",
    "BOX7C_WITHHOLD_RES_PARTNERSHIP_INRST",
    "BOX7D_QUALIFIED_INTERMEDIARY",
    "BOX8_TAX_WITHHELD_OTHER_AGENTS",
    "BOX9_AMOUNT_REPAID_RECIPIENT",
    "BUSINESS_TIN",
    "CFO",
    "INDIVIDUAL_TIN",
    "FILER_FEDERAL_ID_NUMBER",
    "FILER_NAME",
    "FILER_NAME2",
    "FILER_ADDRESS1",
    "FILER_CITY",
    "FILER_STATE",
    "FILER_ZIP",
    "RECIPIENT_ID_NUMBER",
    "1042_YEAR",
    "TAX_YEAR",
    "id",
    "corrected",
  ],
};
